import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "border-b border-gray-200 pb-2" }
const _hoisted_3 = { class: "text-xl font-semibold text-gray-900" }
const _hoisted_4 = {
  key: 0,
  class: "text-sm text-gray-600 mt-1"
}
const _hoisted_5 = { class: "space-y-4" }

import type { StepComponentProps } from '@/types/sellerRegister';


export default /*@__PURE__*/_defineComponent({
  __name: 'StepComponent',
  props: {
    stepNumber: {},
    title: {},
    description: {},
    isActive: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.stepNumber) + ". " + _toDisplayString(_ctx.title), 1),
      (_ctx.description)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.description), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 512)), [
    [_vShow, _ctx.isActive]
  ])
}
}

})